import { memo, useContext, useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import { connect, useDispatch, useSelector } from 'react-redux';

import { AppContext } from '../../../context';

import Style from './JobDetails.module.css';

import { getJobDetails, myApplications } from '../../../redux/actions/aeJobs';

import { Button } from '../../atoms';
import { Footer, Header, JobDescriptionCard, Navbar } from '../../organisms';
import JobDescriptionCardMob from '../../organisms/JobDescriptionCardMob';
import MobileSidebar from '../../organisms/MobileSidebar';
import ApplyJobModal from '../ApplyJob';
import ApplyJobMobModal from '../ApplyJobMob';

const JobDetails = memo((props) => {
  const { isMobile } = useContext(AppContext);
  const currentUser = useSelector((state) => state.currentUser);
  const { loginStatus } = props;

  const router = useRouter();
  const params = router?.query;
  const dispatch = useDispatch();

  // Modal handling sidebar in mobile

  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
  };

  const showModal = () => {
    setOpen(true);
  };

  const toggleModal = () => {
    setOpen(!open);
  };

  // Modal handling application flow in website

  const [openApplication, setOpenApplication] = useState(false);

  const closeAppModal = () => {
    setOpenApplication(false);
  };

  const showAppModal = () => {
    setOpenApplication(true);
  };

  const toggleAppModal = () => {
    setOpenApplication(!openApplication);
  };

  // Modal handling application flow in mobile

  const [openApplicationMob, setOpenApplicationMob] = useState(false);

  const closeAppMobModal = () => {
    setOpenApplicationMob(false);
  };

  const showAppMobModal = () => {
    setOpenApplicationMob(true);
  };

  const toggleAppMobModal = () => {
    setOpenApplicationMob(!openApplicationMob);
  };

  useEffect(() => {
    if (params?.slug) {
      dispatch(getJobDetails(params?.slug))
        .then((data) => {
          const application_open = sessionStorage.getItem('application_open');
          const isJobApplied = data?.data?.job_application ? true : false;

          if (application_open) {
            sessionStorage.removeItem('application_open');

            if (!isJobApplied) {
              if (isMobile) {
                setOpenApplicationMob(true);
              } else {
                setOpenApplication(true);
              }
            }
          }
        })
        .catch(() => {});
      dispatch(
        myApplications({
          conditions: {}
        })
      )
        .then(() => {})
        .catch(() => {});
    }
  }, []);

  const multiSelectHandler = (option) => {
    const stringData = option.map(({ value }) => `${value}`).join(',');

    return stringData;
  };

  const handleSearch = (req_values) => {
    let path = '/jobs/explore?page=1';

    if (req_values?.jobTitle !== '' && req_values?.jobTitle !== null) {
      path = path + `&jobTitle=${req_values?.jobTitle}`;
    }

    if (req_values?.skill !== '' && req_values?.skill !== null) {
      path = path + `&skill=${req_values?.skill}`;
    }

    if (req_values?.duration !== '' && req_values?.duration !== null) {
      path = path + `&duration=${req_values?.duration?.value}`;
    }

    if ((req_values?.location || []).length != 0) {
      const locationList = multiSelectHandler(req_values?.location);

      path = path + `&location=${locationList}`;
    }

    router.push(path);
  };

  const page = router?.query?.prevPage;

  const handleBackBtn = () => {
    if (page) {
      if (page.split('?')?.[1]) {
        if (page.includes('jobId')) {
          const searchParams = new URLSearchParams('?' + router?.query?.prevPage.split('?')?.[1]);

          searchParams.set('jobId', params?.slug);
          const newurl = page.split('?')?.[0] + '?' + searchParams.toString();

          router.push(newurl);
        } else {
          router.push(`${page}&jobId=${params?.slug}`);
        }
      } else {
        router.push({
          pathname: `${page}`,
          query: { jobId: params?.slug }
        });
      }
    } else {
      router?.back();
    }
  };

  return (
    <>
      {isMobile ? (
        <>
          <Navbar loginStatus={loginStatus} showSidebar={showModal} />
          <MobileSidebar closeModal={closeModal} open={open} toggleModal={toggleModal} />
          <div className='container padding0'>
            <div className={Style.jobDisplaySpace}>
              <div className='padding32B'>
                <div className={`${Style.jobDescriptionContainer} padding0`} style={{ backgroundColor: '#FFFFFF' }}>
                  <Button className='no-border-btn' onClick={router?.back}>
                    <img src='/images/job-dashboard/arrow-left-mob.svg' />
                    Back
                  </Button>
                  <JobDescriptionCardMob showModal={showAppMobModal} />
                </div>
              </div>
            </div>
          </div>
          <ApplyJobMobModal closeModal={closeAppMobModal} open={openApplicationMob} toggleModal={toggleAppMobModal} />
        </>
      ) : (
        <>
          <Navbar loginStatus={loginStatus} />
          <Header handleSearch={handleSearch} />
          <div className={Style.jobDisplaySpace}>
            <div className='container'>
              <div className='padding32B'>
                <div className='padding16T'>
                  <Button className='general-outline-style' onClick={handleBackBtn}>
                    <img src='/images/job-dashboard/arrow-left.svg' />
                    <div className='marginTopAuto'>Back</div>
                  </Button>
                </div>
                {currentUser?.data ? (
                  <div className='row margin-0'>
                    <div className={`col-9 ${Style.jobDescriptionContainer} padding0`}>
                      <JobDescriptionCard showModal={showAppModal} />
                    </div>
                    <div className={`col-3 ${Style.jobDescriptionRefer} `}>
                      <div>
                        <img src='/images/header-images/Cycling.svg' />
                        <div>
                          Refer your friend to Awign Expert & Earn INR <span>40,000</span> for each selection
                        </div>
                        <a href='https://wa.me/919164277011?text=Refer%20and%20earn'>
                          <Button className='whatsapp-btn'>Refer via Whatsapp</Button>
                        </a>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='row margin-0'>
                    <div className={`col-12 ${Style.jobDescriptionContainer} padding0`}>
                      <JobDescriptionCard showModal={showAppModal} />
                    </div>
                  </div>
                )}
              </div>
              <ApplyJobModal closeModal={closeAppModal} open={openApplication} toggleModal={toggleAppModal} />
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
});

JobDetails.displayName = 'JobDetails';

JobDetails.defaultProps = {
  hideModal: () => {}
};

export default connect(null, {})(JobDetails);
